const defaultState = {
  event: undefined,
};

export const androidDownloadReducer = (_state = defaultState, _action: any) => {
  switch (_action.type) {
    case "SET_EVENT_DOWNLOAD": {
      return { ..._state, event: _action.payload };
    }
    default: {
      return _state;
    }
  }
};
